<template>
    <div class="newProd">
        <go-back class="goBack" />
        <img src="./img/01.png" />
        <div class="imgBox">
            <span 
             class="btn btn1"
             @click="btnClick('hybird://method/openBukeListenCourseDetail?courseId=96')"
            >试听</span>
            <img src="./img/02.jpg" />
        </div>
        <div class="imgBox">
            <span 
            class="btn btn2"
            @click="btnClick('hybird://method/openBukeListenCourseDetail?courseId=98')"
            >试听</span>
            <img src="./img/03.jpg" />
        </div>
        <div class="imgBox">
            <span
            class="btn btn3"
            @click="btnClick('hybird://method/openBukeListenCourseDetail?courseId=97')"
            >试听</span>
            <img src="./img/04.jpg" />
        </div>
        <img @click="addVip" class="bottom_btn" src="./img/btn.png" />
    </div>
</template>

<script>
import goBack from "@/components/goBack/goBack.vue";
import utils from "@/assets/js/utils";
import { isIOS, isAndroid } from '@/utils/env';
const token = utils.getQueryString('token');
const version = utils.getQueryString('version');
const source = utils.getQueryString('source');
const categoryId = utils.getQueryString('categoryId');
const pageChannelId = utils.getQueryString('pageChannel');
const productId = utils.getQueryString('productId');    //商品Id

export default {
    name: "newprod",
    components:{
        goBack
    },
    data() {
        return {
            urlParams:''
        }
    },
    created(){
        let urlParams = this.$route.fullPath.split('?')[1];
        this.urlParams = urlParams;
    },
    methods: {
        addVip(){
            if(isIOS()){
                this.$router.push('/member/member_ios?'+this.urlParams)
            }else if(isAndroid()){
                this.$router.push('/member/member_and?'+this.urlParams)
            }
        },
        btnClick(url){
            window.location.href = url;
        }
    }
}
</script>

<style lang="scss" scoped>
.newProd{
    position: relative;
    .goBack{
        position: fixed;
        top: .25rem;
        left: .25rem;
        z-index: 1000;
    }
    img{
        display: block;
        width: 100vw;
    }
    .bottom_btn{
        transform:translateX(-50%);
        width: 6.89rem;
        position: fixed;
        bottom: .76rem;
        left: 50%;
    }
    .imgBox{
        position: relative;
    }
    .btn{
        position: absolute;
        width: 1.32rem;
        height: .58rem;
        line-height: .58rem;
        background-color: #ff6612;
        border-radius: .29rem;
        font-size: .32rem;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0;
        color: #ffffff;
        text-align: center;
        left: 5.66rem;
    }
    .btn1{
        top: 3.19rem;
    }
    .btn2{
        top: 3.62rem;
    }
    .btn3{
        top: 3.53rem;
    }
}
</style>